import { html } from "htm/preact";
import { useEffect, useState } from "preact/hooks";
import { getClient } from "../client.js";
import { loadCourse } from "../courseData.js";
import { NotJoined } from "../components/NotJoined.js";
import { RulesPanel } from "../components/RulesPanel.js";
import type { Course } from "../../../shared/types.js";

export function RoundRules({ code, roundId }: { code: string; roundId: string }) {
  const client = getClient(code);
  const snapshot = client?.snapshot.value ?? null;
  const round = snapshot?.tournament.rounds.find((r) => r.id === roundId) ?? null;

  /**
   * The round's course, purely so the rules can say how many holes it is.
   *
   * Fetched here rather than passed in because this screen is reached directly by URL
   * from the scorecard and holds nothing else. Failure is silence: the rules still
   * render, and fall back to assuming eighteen holes, which is what they said before
   * nine-hole courses existed.
   */
  const [course, setCourse] = useState<Course | null>(null);
  useEffect(() => {
    let live = true;
    setCourse(null);
    if (!round?.courseId) return undefined;
    loadCourse(round.courseId)
      .then((c) => {
        if (live) setCourse(c);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [round?.courseId]);

  if (!client) return html`<${NotJoined} code=${code} />`;
  if (!snapshot || !round) return html`<p>Loading…</p>`;

  const teeSet = course?.teeSets.find((t) => t.name === round.teeSet);

  return html`
    <h1>Rules</h1>
    <${RulesPanel} round=${round} players=${snapshot.tournament.players} teeSet=${teeSet} />
    <p><a href="#/t/${code}/round/${roundId}">← Back to scorecard</a></p>
  `;
}
